import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconStarfull: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.8999 9.1C21.6997 8.6 21.2992 8.2 20.6986 8.1L15.5931 7.4L13.2906 2.8C13.0904 2.3 12.5899 2 11.9892 2C11.3886 2 10.888 2.3 10.6878 2.8L8.38534 7.4L3.27984 8.1C2.67919 8.2 2.27876 8.6 2.07855 9.1C1.87833 9.6 2.07855 10.2 2.47898 10.6L6.18297 14.1L5.282 19.1C5.18189 19.7 5.3821 20.2 5.88264 20.6C6.28307 21 6.88372 21 7.38426 20.8L11.9892 18.4L16.5942 20.8C16.7944 20.9 17.0947 21 17.2949 21C17.5953 21 17.8956 20.9 18.1959 20.7C18.6964 20.4 18.8967 19.8 18.7965 19.2L17.8956 14.2L21.5996 10.6C22 10.3 22.1001 9.7 21.8999 9.1Z',
    })
  )
}
